export enum OperationGroup {
  QUERY = 'QUERY',
  BACKUP = 'BACKUP',
  CLUSTER = 'CLUSTER',
  IMPORT = 'IMPORT'
}
